import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../../../components/Common/Actions";
import FilledButton from "../../../../components/Common/Buttons/FilledButton";
import CommonFilterModal from "../../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";
import ListPageLayout from "../../../../components/Layout";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";
import {
  DocterBreadcrumbs,
  DocternavBarData,
  statuses,
} from "../../Utils/MasterConst";

const fees = [
  "Less than INR 99",
  "INR 100 to INR 299",
  "INR 300 to INR 499",
  "INR 500 to INR 799",
  "INR 800 to INR 999",
  "More than INR 1000",
];

const InClinicFee = () => {
  const navigate = useNavigate();

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    "In-Clinic Fee": [],
    Status: [],
  });
  const [tempSelectedValues, setTempSelectedValues] = useState({
    "In-Clinic Fee": [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("In-Clinic Fee");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setLoader] = useState(true);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}in-clinic-fee/list`,
      initialParams: {
        searchText: search,
        selectedValues,
        sort,
        noLimit: true,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "in-clinic-fee",
    fetchData,
    setShowDelete,
  );

  //addNewSpecialization
  const addNewInClinicFee = {
    id: "addnewpost",
    onClick: () => navigate("/master-in-clinic-create"),
    className: "addnewhealth",
    style: { width: "240px" },
    label: "Add New  In-Clinic Fee",
  };

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search, selectedValues]);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "In-Clinic Fee",
      dataIndex: "type",
      key: "type",
      width: 250,
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      width: 150,
      render: (active) => (active ? "Verified" : "Not Verified"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isEdit={true}
            isDelete={true}
            isView={true}
            onClickView={() => navigate(`/master-inclinic-view/${record._id}`)}
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
            onClickEdit={() => navigate(`/master-inclinic-edit/${record._id}`)}
          />
        </div>
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const filters = {
    "In-Clinic Fee": fees,
    Status: statuses,
  };
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<DocterBreadcrumbs last="In-Clinic Fee" />}
      addButton={<FilledButton props={addNewInClinicFee} />}
      titles={<NavBarTitles titles={DocternavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        onReset={() => {
          setTempSelectedValues({ "In-Clinic Fee": [], Status: [] });
          setSelectedValues({ "In-Clinic Fee": [], Status: [] });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default InClinicFee;
